import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// material-ui
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

// assets
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import ExportOutlined from '@ant-design/icons/ExportOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);

  // Sync state dengan rute saat ini
  useEffect(() => {
    const path = location.pathname;
    if (path === '/' || path.includes('/dashboard')) setValue(0);
    else if (path.includes('/masuk')) setValue(1);
    else if (path.includes('/keluar')) setValue(2);
    else if (path.includes('/laporan')) setValue(3);
  }, [location]);

  return (
    <Paper
      sx={{
        display: { xs: 'block', md: 'none' }, // Sembunyikan di desktop
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000, // di atas konten
        bgcolor: '#ffffff', // latar belakang putih bersih
        boxShadow: '0 -4px 16px rgba(0,0,0,0.08)',
        borderTop: '1px solid #e2e8f0' // garis tipis pemisah
      }}
      elevation={0}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          // Navigasi ke menu utama mobile
          switch (newValue) {
            case 0:
              navigate('/dashboard/default');
              break;
            case 1:
              navigate('/gudang/daftar-masuk');
              break;
            case 2:
              navigate('/gudang/daftar-keluar');
              break;
            case 3:
              navigate('/gudang/laporan-masuk');
              break;
            default:
              break;
          }
        }}
        sx={{
          bgcolor: 'transparent',
          height: 56, // compact & responsive height
          '& .MuiBottomNavigationAction-root': {
            color: '#64748b', // abu-abu lembut saat tidak aktif
            minWidth: 'auto',
            padding: '4px 0'
          },
          '& .Mui-selected': {
            color: '#1890ff !important', // biru primary saat aktif
            fontWeight: 'bold'
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.68rem', // font kecil & rapi
            mt: 0.2
          }
        }}
      >
        <BottomNavigationAction label="HOME" icon={<HomeOutlined style={{ fontSize: '1.15rem' }} />} />
        <BottomNavigationAction label="Barang Masuk" icon={<InboxOutlined style={{ fontSize: '1.15rem' }} />} />
        <BottomNavigationAction label="Barang Keluar" icon={<ExportOutlined style={{ fontSize: '1.15rem' }} />} />
        <BottomNavigationAction label="Laporan" icon={<FileTextOutlined style={{ fontSize: '1.15rem' }} />} />
      </BottomNavigation>
    </Paper>
  );
}

